import React from 'react';
import './illustrations.css';

/**
 * Offline Illustration.
 * Represents a satellite dish with a broken signal, indicating loss of connectivity.
 * Used on the global offline overlay.
 */
export const OfflineIllustration: React.FC = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 400 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', maxWidth: 400 }}
  >
    {/* Satellite antenna base */}
    <rect x="185" y="230" width="30" height="40" rx="4" fill="#374151" />
    <rect x="175" y="265" width="50" height="8" rx="4" fill="#4B5563" />
    {/* Dish arm */}
    <line x1="200" y1="230" x2="200" y2="180" stroke="#6B7280" strokeWidth="4" />
    {/* Dish */}
    <ellipse cx="200" cy="170" rx="50" ry="20" fill="#374151" />
    <ellipse cx="200" cy="165" rx="46" ry="16" fill="#4B5563" />
    {/* Center point */}
    <circle cx="200" cy="155" r="5" fill="var(--cb-accent)" />
    {/* Signal waves (animated, staggered) */}
    <path
      d="M200 120 Q230 100 200 80 Q170 100 200 120"
      stroke="var(--cb-accent)"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      className="illustration-signal"
      style={{ animationDelay: '0s' }}
    />
    <path
      d="M200 100 Q250 70 200 40 Q150 70 200 100"
      stroke="var(--cb-accent)"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
      className="illustration-signal"
      style={{ animationDelay: '0.3s' }}
    />
    <path
      d="M200 80 Q270 40 200 0 Q130 40 200 80"
      stroke="var(--cb-accent)"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      className="illustration-signal"
      style={{ animationDelay: '0.6s' }}
      opacity="0"
    />
    {/* Broken signal cross */}
    <line
      x1="170"
      y1="50"
      x2="230"
      y2="110"
      stroke="#EF4444"
      strokeWidth="3"
      strokeLinecap="round"
      opacity="0.7"
    />
    <line
      x1="230"
      y1="50"
      x2="170"
      y2="110"
      stroke="#EF4444"
      strokeWidth="3"
      strokeLinecap="round"
      opacity="0.7"
    />
    {/* Stars */}
    <circle cx="40" cy="30" r="1.5" fill="white" opacity="0.4" />
    <circle cx="360" cy="50" r="1" fill="white" opacity="0.5" />
    <circle cx="350" cy="200" r="1.5" fill="white" opacity="0.3" />
  </svg>
);
